// 组件预览容器的默认宽高
export const DEFAULT_CODE_PREVIEW_COMPONENT_WIDTH = 1000;
export const DEFAULT_CODE_PREVIEW_COMPONENT_HEIGHT = 358;

// 自定义生成组件的入口组件的默认宽高
export const DEFAULT_CUSTOM_INIT_WIDTH = 1000;
export const DEFAULT_CUSTOM_INIT_HEIGHT = 430;
// 独立卡片模式下
export const DEFAULT_CUSTOM_INIT_HEIGHT_IN_CARD = 489;

/** 上报 id 映射表 */
export const LogIdMap = {
    /** 自定义组件模块添加 */
    CreateCustomInit: '80001.2.352',
    /** 自定义组件上点击自定义 */
    SelectCustomFromCustomInit: '80001.2.353',
    /** 模版插入 */
    CreateComponentByTemplate: '80001.2.354',
    /** 创作助理对话次数 */
    ChatCount: '80001.2.355',
    /** 代码编辑 */
    CodeEditCount: '80001.2.356',
    /** 组件展示次数 */
    ShowComponent: '80001.2.357',
    /** 组件交互次数 */
    InteractComponent: '80001.2.358',
    /** 对话生成组件完成 */
    GenerateArtifactComplete: '80001.2.359',
    /** 使用说明&群号点击 */
    ClickGuidance: '80001.2.377',
    /** 复制按钮 */
    CopyButton: '80001.2.379',
    /** 申请自定义 */
    ApplyCustomInit: '80001.2.381',
    /** 独立成卡 / 取消独立成卡 */
    SplitOrMerge: '80001.2.380',
};

// 随心搭如流群号
export const RuliuGroupId = '11717613';
